"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicClerkContext = exports.IsomorphicClerkContext = void 0;
const makeContextAndHook_1 = require("../utils/makeContextAndHook");
/**
 * @internal
 */
_a = (0, makeContextAndHook_1.makeContextAndHook)('IsomorphicClerkContext'), exports.IsomorphicClerkContext = _a[0], exports.useIsomorphicClerkContext = _a[1];
//# sourceMappingURL=IsomorphicClerkContext.js.map